<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { isLoggedIn } from './store/session';
import TabBar from './components/TabBar.vue';

const route = useRoute();

/** 只在这四个主入口显示底部导航，二级页面不显示 */
const TAB_ROUTES = ['home', 'scan', 'products', 'me'];
const showTabbar = computed(
  () => isLoggedIn.value && TAB_ROUTES.includes(String(route.name)),
);
</script>

<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>

  <TabBar v-if="showTabbar" />
</template>
